<template>
  <div class="gift-message">
    <div class="gift-message__form">
      <div class="gift-message__edit">
        <div class="form-group">
          <label
            class="form-group__label text-body-s"
            for="to"
            v-text="`${$string('product.gift_message.to')}*`"
          />
          <input
            id="to"
            v-model="giftMessageTo"
            type="text"
            name="properties[gift_message_to]"
          >
          <span
            v-if="giftMessageToError"
            class="form-group__error"
            v-text="$string('product.gift_message.required')"
          />
        </div>

        <div class="form-group">
          <label
            class="form-group__label text-body-s"
            for="from"
            v-text="`${$string('product.gift_message.from')}*`"
          />
          <input
            id="from"
            v-model="giftMessageFrom"
            type="text"
            name="properties[gift_message_from]"
          >
          <span
            v-if="giftMessageFromError"
            class="form-group__error"
            v-text="$string('product.gift_message.required')"
          />
        </div>

        <div class="form-group">
          <label
            class="form-group__label text-body-s"
            for="message"
            v-text="$string('product.gift_message.message')"
          />
          <textarea
            id="message"
            v-model="giftMessage"
            name="properties[gift_message_message]"
            cols="30"
            rows="10"
            maxlength="250"
            :placeholder="$string('product.gift_message.add_gift_message')"
          />

          <div
            class="product-form__disclaimer text-body-s"
            v-html="giftDisclaimer"
          />
        </div>

        <div
          v-if="editMessage"
          class="line-item__actions"
        >
          <button
            class="
              button
              cart-drawer__gift-message-action
              cart-drawer__gift-message-remove
              text-body-s-link-desktop"
            @click="cancelEdit"
            v-html="'Cancel'"
          />

          <button
            class="
              button
              cart-drawer__gift-message-action
              cart-drawer__gift-message-remove
              text-body-s-link-desktop"
            @click="saveEdit"
            v-html="'Save'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Gift Message
 * -----------------------------------------------------------------------------
 * A section to fill in space for development.
 * - Static section.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'GiftMessage',
  props: {
    cart: {
      type: Object,
      default: () => ({
      }),
    },
    hasGiftMessage: {
      type: Boolean,
      default: false,
    },
    messageTo: {
      type: String,
      default: '',
    },
    messageFrom: {
      type: String,
      default: '',
    },
    messageMessage: {
      type: String,
      default: '',
    },
    editMessage: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
  'validate-gift-message', 'remove-gift-message', 'cancel-edit', 'save-message',
  ],

  data() {
    return {
      giftMessageTo: this.messageTo,
      giftMessageFrom: this.messageFrom,
      giftMessage: this.messageMessage,
      giftMessageToError: false,
      giftMessageFromError: false,
      giftMessageMaxLength: 250,
      giftDisclaimer: `
        <p class="text-body-s product-form__disclaimer-copy">250/250 ${this.$string('product.gift_message.remaining')}</p>
        <p class="text-body-s product-form__disclaimer-copy">${this.$string('product.gift_message.disclaimer')}</p>
      `,
    }
  },

  watch: {
    giftMessageTo() {
      this.handleFieldValidation()
    },
    giftMessageFrom() {
      this.handleFieldValidation()
    },
    giftMessage() {
      this.giftDisclaimer = `
        <p class="text-body-s product-form__disclaimer-copy">${this.giftMessageMaxLength - this.giftMessage.length}/${this.giftMessageMaxLength} ${this.$string('product.gift_message.remaining')}</p>
        <p class="text-body-s product-form__disclaimer-copy">${this.$string('product.gift_message.disclaimer')} </p>
      `

      this.handleFieldValidation()
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      updateCartAttributes: 'cart/updateCartAttributes',
      clearCartAttributes: 'cart/clearCartAttributes',
    }),

    async handleRemoveGiftMessage(event) {
      event.preventDefault()

      try {
        this.clearCartAttributes()
      } catch(error) {
        reportError('Failed to update cart', error)
      }

      this.$emit('remove-gift-message')
    },

    handleFieldValidation() {
      if(!this.hasGiftMessage) {
        this.hasFormErrors = false
        this.giftMessageToError = false
        this.giftMessageFromError = false
        return
      }


      if (this.giftMessageTo) {
        this.giftMessageToError = this.giftMessageTo.length > 0 ? false : true
      }

      if (this.giftMessageFrom) {
        this.giftMessageFromError = this.giftMessageFrom.length > 0 ? false : true
      }

      if (this.giftMessageToError || this.giftMessageFromError) {
        this.hasFormErrors = true
        return true
      }

      this.hasFormErrors = false
      this.$emit('validate-gift-message', {
        errors: this.hasFormErrors,
        to: this.giftMessageTo,
        from: this.giftMessageFrom,
        message: this.giftMessage,
      })
      return
    },

    cancelEdit(event) {
      event.preventDefault()
      this.$emit('cancel-edit')
    },

    saveEdit(event) {
      event.preventDefault()
      this.$emit('save-message', {
        errors: this.hasFormErrors,
        to: this.giftMessageTo,
        from: this.giftMessageFrom,
        message: this.giftMessage,
      })
    },
  },
}
</script>

<style lang="scss">
@import './gift-message';
</style>
